import { render, staticRenderFns } from "./versionesAutos.vue?vue&type=template&id=fa908400&"
import script from "./versionesAutos.vue?vue&type=script&lang=ts&"
export * from "./versionesAutos.vue?vue&type=script&lang=ts&"
import style0 from "./versionesAutos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports